/* ATELIER theme.js — vanilla, no frameworks. Cart AJAX + UI plumbing. */
(function () {
  'use strict';

  var overlay;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function getOverlay() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'page-overlay';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', closeAllPanels);
    }
    return overlay;
  }

  var lastFocused = null;
  var FOCUSABLE = 'button:not([disabled]), a[href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function openPanel(el) {
    lastFocused = document.activeElement;
    el.setAttribute('aria-hidden', 'false');
    getOverlay().classList.add('is-active');
    document.body.style.overflow = 'hidden';
    var focusable = el.querySelector(FOCUSABLE);
    if (focusable) focusable.focus();
  }

  function closePanel(el) {
    el.setAttribute('aria-hidden', 'true');
  }

  function closeAllPanels() {
    var wasOpen = qsa('[data-panel][aria-hidden="false"]').length > 0;
    qsa('[data-panel]').forEach(closePanel);
    if (overlay) overlay.classList.remove('is-active');
    document.body.style.overflow = '';
    if (wasOpen && lastFocused && document.contains(lastFocused)) {
      lastFocused.focus();
      lastFocused = null;
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAllPanels(); return; }
    /* focus trap inside open dialog */
    if (e.key === 'Tab') {
      var open = qs('[data-panel][aria-hidden="false"]');
      if (!open) return;
      var items = qsa(FOCUSABLE, open).filter(function (n) { return n.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- money formatting ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1]);
  }

  /* ---------- cart ---------- */
  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCartDrawer(openAfter) {
    var drawer = qs('#CartDrawer');
    return fetch(window.theme.routes.cart_url + '?section_id=cart-drawer-items')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (drawer) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-drawer-content]');
          var target = drawer.querySelector('[data-drawer-content]');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        }
        return fetch(window.theme.routes.cart_url + '.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (openAfter && drawer) openPanel(drawer);
        return cart;
      });
  }

  function addToCart(formDataOrId, quantity) {
    var body;
    if (formDataOrId instanceof FormData) {
      body = formDataOrId;
    } else {
      body = new FormData();
      body.append('id', formDataOrId);
      body.append('quantity', quantity || 1);
    }
    return fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch(window.theme.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t;

    /* open cart drawer */
    t = e.target.closest('[data-cart-open]');
    if (t && window.theme.cartType === 'drawer') {
      e.preventDefault();
      refreshCartDrawer(true);
      return;
    }

    /* close buttons */
    t = e.target.closest('[data-panel-close]');
    if (t) { closeAllPanels(); return; }

    /* mobile menu */
    t = e.target.closest('[data-menu-open]');
    if (t) { openPanel(qs('#MobileMenu')); return; }

    /* search overlay */
    t = e.target.closest('[data-search-open]');
    if (t) {
      var so = qs('#SearchOverlay');
      openPanel(so);
      var input = so && so.querySelector('input[type="search"]');
      if (input) input.focus();
      return;
    }

    /* quick add */
    t = e.target.closest('[data-quick-add]');
    if (t) {
      e.preventDefault();
      var id = t.getAttribute('data-quick-add');
      var original = t.textContent;
      t.disabled = true;
      t.textContent = window.theme.strings.adding;
      addToCart(id, 1)
        .then(function () {
          if (window.theme.cartType === 'drawer') {
            return refreshCartDrawer(true);
          }
          return fetch(window.theme.routes.cart_url + '.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) { updateCartCount(cart.item_count); });
        })
        .catch(function (err) {
          alert((err && err.description) || 'Could not add to cart.');
        })
        .finally(function () {
          t.disabled = false;
          t.textContent = original;
        });
      return;
    }

    /* qty +/- and remove (cart page + drawer) */
    t = e.target.closest('[data-qty-change]');
    if (t) {
      var line = t.closest('[data-line-key]');
      var input2 = line.querySelector('[data-qty-input]');
      var next = parseInt(input2.value, 10) + parseInt(t.getAttribute('data-qty-change'), 10);
      if (next < 0) next = 0;
      setLineQty(line, next);
      return;
    }
    t = e.target.closest('[data-line-remove]');
    if (t) {
      var line2 = t.closest('[data-line-key]');
      setLineQty(line2, 0);
      return;
    }
  });

  function setLineQty(lineEl, qty) {
    var key = lineEl.getAttribute('data-line-key');
    lineEl.style.opacity = '0.4';
    changeLine(key, qty).then(function (cart) {
      updateCartCount(cart.item_count);
      if (lineEl.closest('#CartDrawer')) {
        refreshCartDrawer(false);
      } else {
        window.location.reload();
      }
    });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) {
      var line = input.closest('[data-line-key]');
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 0) v = 1;
      setLineQty(line, v);
    }
  });

  /* ---------- PDP: variant selection ---------- */
  function initProductForm(form) {
    var json = form.getAttribute('data-variants');
    if (!json) return;
    var variants = JSON.parse(json);
    var idInput = form.querySelector('[name="id"]');
    var button = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-price-wrap]');

    function selectedOptions() {
      var opts = [];
      qsa('fieldset', form).forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function onChange() {
      var variant = findVariant(selectedOptions());
      if (!variant) {
        button.disabled = true;
        button.textContent = window.theme.strings.unavailable;
        return;
      }
      idInput.value = variant.id;
      if (variant.available) {
        button.disabled = false;
        button.textContent = window.theme.strings.addToCart;
      } else {
        button.disabled = true;
        button.textContent = window.theme.strings.soldOut;
      }
      if (priceEl) {
        var html = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = '<span class="price--sale"><span class="price__current">' + formatMoney(variant.price) +
                 '</span><s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s></span>';
        }
        priceEl.innerHTML = html;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) onChange();
    });

    form.addEventListener('submit', function (e) {
      if (window.theme.cartType !== 'drawer') return; /* let it POST normally */
      e.preventDefault();
      var original = button.textContent;
      button.disabled = true;
      button.textContent = window.theme.strings.adding;
      addToCart(new FormData(form))
        .then(function () { return refreshCartDrawer(true); })
        .catch(function (err) { alert((err && err.description) || 'Could not add to cart.'); })
        .finally(function () {
          button.disabled = false;
          button.textContent = original;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    qsa('[data-product-form]').forEach(initProductForm);

    /* collection sort */
    var sort = qs('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        window.location.href = url.toString();
      });
    }
  });
})();
